import React from "react";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

const cache = new Map();

export function useDeleteVictim(token, victim_id, shouldDelete = false) {
  const [error, setError] = React.useState();
  const [isDeleteVictimComplete, setIsDeleteVictimComplete] = React.useState(false);

  React.useEffect(() => {
    if (token && victim_id && shouldDelete) {        
        setError(undefined);

        const headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Origin", "{location.protocol + '//' + location.host}");
        const options = {
          method: "DELETE",
          headers: headers,
          redirect: "follow",
          cache: "no-cache",
        };

        /**
         * Make request
         */
        fetch(`${PATHS.apiVictims}/${victim_id}/archive`, options)
          .then((response) => {
            setIsDeleteVictimComplete(true);
            return response.json();
          })
          .catch((error) => setError(error))
          
        }
    
  }, [token, victim_id, shouldDelete]);

  return { isDeleteVictimComplete, deleteVictimError: error  };
}
